import { useMemo } from 'react';
import { useCreateSubteam, useRenameTeam } from '../api/postApi';
import {
  CommonTeamDialogType,
  CreateSubteamAndRenameActionProps,
  TeamAccordionItemAction,
} from '../../components/app/base/TeamAccordionItem/TeamAccordionItem.types';
import { useTeamMembersContext } from '../context/TeamMembersContext';
import { ConfirmDialogProps } from '../../components/common/ConfirmDialog/ConfirmDialogTypes';
import { replaceObjectPlaceholders } from '../utils/placeholders/replacePlaceholder';
import { TEAM_MANAGMENT_LABELS } from '../constants/labelKeys';
import { Api } from '../types/apiSpec';

export const useCreateSubteamAndRenameDialogProps = ({
  type,
  teamMeta,
}: {
  teamMeta: Api.TeamSummary;
  type: CommonTeamDialogType;
}) => {
  const createSubTeam = useCreateSubteam(teamMeta.id);
  const renameTeam = useRenameTeam(teamMeta.id);

  const { createSubteamDialogTitle, createSubteamSuccessMessage, renameTeamDialogTitle, renameTeamSuccessMessage } =
    useTeamMembersContext();

  const dialogCommonProps: Record<
    CommonTeamDialogType,
    Pick<ConfirmDialogProps, 'dialogTitle' | 'labelKeys'> & { actionProps: CreateSubteamAndRenameActionProps }
  > = {
    [TeamAccordionItemAction.CREATE_SUBTEAM]: {
      dialogTitle: replaceObjectPlaceholders(teamMeta, createSubteamDialogTitle),
      labelKeys: {
        confirmButton: TEAM_MANAGMENT_LABELS.createSubTeamDialog.CONFIRM_BUTTON,
      },
      actionProps: {
        action: createSubTeam,
        successMessage: createSubteamSuccessMessage,
      },
    },
    [TeamAccordionItemAction.RENAME_TEAM]: {
      dialogTitle: replaceObjectPlaceholders(teamMeta, renameTeamDialogTitle),
      labelKeys: {
        confirmButton: TEAM_MANAGMENT_LABELS.renameTeamDialog.CONFIRM_BUTTON,
      },
      actionProps: {
        action: renameTeam,
        successMessage: renameTeamSuccessMessage,
      },
    },
  };

  return useMemo(() => dialogCommonProps[type], [type, teamMeta]);
};
